module.exports = __webpack_public_path__ + "img/title.5a3a665e.png";